import React from "react";

import cx from "classnames";

import styles from "./Grid.scss";

export interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Use gutters between grid items. Default: true. USE FALSE SPARINGLY.
   */
  gutters?: boolean;
  /**
   * Add outer padding to the grid. Default: false. You should never need to use true here.
   */
  outerPadding?: boolean;
  /**
   * Never break based on screen size. Default: false. USE TRUE SPARINGLY.
   */
  strict?: boolean;
  /**
   * Sets the vertical gutter size. Default: null.
   */
  verticalGutter?:
    | "none"
    | "tiny"
    | "small"
    | "little"
    | "default"
    | "medium"
    | "large"
    | "extra-large";
  /**
   * Sets the horizontal gutter size. Default: null.
   */
  horizontalGutter?:
    | "none"
    | "tiny"
    | "small"
    | "little"
    | "default"
    | "medium"
    | "large"
    | "extra-large";
}

export function Grid({
  gutters = true,
  strict = false,
  outerPadding = false,
  verticalGutter,
  horizontalGutter,
  ...props
}: GridProps) {
  props.className = cx(props.className || "", styles.grid, {
    [styles.noGutters]: !gutters,
    [styles.strict]: strict,
    [styles.outerPadding]: outerPadding,
    [styles[`horizontal-spacing-${horizontalGutter}`]]: !!horizontalGutter,
    [styles[`vertical-spacing-${verticalGutter}`]]: !!verticalGutter,
  });
  return <div {...props} />;
}
